import { render } from "./Projects.vue?vue&type=template&id=7f7a2553&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=7f7a2553&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7f7a2553"

export default script